import { LuArrowDownAZ, LuArrowDownNarrowWide, LuArrowDownWideNarrow, LuArrowDownZA } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { TaskSortOption, useTaskViewState } from '../task-state';

const sortOptionLabel: Record<TaskSortOption, string> = {
    [TaskSortOption.DUE_DATE]: 'Due Date',
    [TaskSortOption.HOUSEHOLD]: 'Household',
    [TaskSortOption.ASSIGNEE]: 'Assignee',
    [TaskSortOption.TASK_TYPE]: 'Task Type',
};

const ascendingLabel: Record<TaskSortOption, string> = {
    [TaskSortOption.DUE_DATE]: 'Oldest First',
    [TaskSortOption.HOUSEHOLD]: 'A to Z',
    [TaskSortOption.ASSIGNEE]: 'A to Z',
    [TaskSortOption.TASK_TYPE]: 'A to Z',
};

const descendingLabel: Record<TaskSortOption, string> = {
    [TaskSortOption.DUE_DATE]: 'Newest First',
    [TaskSortOption.HOUSEHOLD]: 'Z to A',
    [TaskSortOption.ASSIGNEE]: 'Z to A',
    [TaskSortOption.TASK_TYPE]: 'Z to A',
};

const SORT_OPTIONS = Object.values(TaskSortOption);

export const TaskSortDropdownMenu = () => {
    const { taskViewState, setTaskViewState } = useTaskViewState();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline2" size="sm" className="flex items-center gap-2">
                    <TaskSortIcon />
                    {sortOptionLabel[taskViewState.sortOption]}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                {SORT_OPTIONS.map((sortOption: TaskSortOption) => (
                    <DropdownMenuCheckboxItem
                        key={sortOption}
                        checked={taskViewState.sortOption === sortOption}
                        onSelect={() => setTaskViewState({ sortOption: sortOption })}
                    >
                        {sortOptionLabel[sortOption]}
                    </DropdownMenuCheckboxItem>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuCheckboxItem
                    checked={taskViewState.sortDirection === 'asc'}
                    onSelect={() => setTaskViewState({ sortDirection: 'asc' })}
                >
                    {ascendingLabel[taskViewState.sortOption]}
                </DropdownMenuCheckboxItem>
                <DropdownMenuCheckboxItem
                    checked={taskViewState.sortDirection === 'desc'}
                    onSelect={() => setTaskViewState({ sortDirection: 'desc' })}
                >
                    {descendingLabel[taskViewState.sortOption]}
                </DropdownMenuCheckboxItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

const TaskSortIcon = () => {
    const { taskViewState } = useTaskViewState();
    const sortDirection = taskViewState.sortDirection;
    const isAsc = sortDirection === 'asc';

    if (taskViewState.sortOption === TaskSortOption.DUE_DATE) {
        return isAsc ? <LuArrowDownNarrowWide className="mt-[2px]" /> : <LuArrowDownWideNarrow className="mt-[2px]" />;
    }

    return isAsc ? <LuArrowDownAZ className="mt-[2px]" /> : <LuArrowDownZA className="mt-[2px]" />;
};
